import { createSlice, current } from '@reduxjs/toolkit'
import { updateTaskR } from '../../../reducers/models/menuData';
import { useDispatch } from 'react-redux';

function filterProjectGenerate(list, id_tab) {
    /*
            id - ИД проекта
            name - Название проекта
            count - Кол-во элементов в проекте   
    */
    var filter_list = [];

    list.filter(a => a.ID_Project != null).map(item => {
        if (filter_list.filter(a => a.id === item.ID_Project).length === 0) {
            filter_list.push({ id: item.ID_Project, name: item.Name_Project, count: list.filter(a => a.ID_Project === item.ID_Project).length, id_tab: id_tab })
        }
    })
    return filter_list;
}
//Определит id_tab задачи
function taskTabGet(model) {
    var id_tab = null;

    //Наблюдатель
    if (model.ID_Action === 1) {
        id_tab = 1;
    }
    //Исполнитель
    if (model.ID_Action === 2) {
        id_tab = 0;
    }

    return id_tab;
}

const taskRTrackerList = createSlice({
    name: 'taskRTrackerList',
    initialState: {
        list: [],//Список задач
        listLoaded: [],//Флаг состояния загрузки задач

        listCheckList: [],//Список чек-листов
        listUser: [],//Список пользователей задач
        listLabel: [],//Список меток задач

        //filterUser: [],//Фильр пользователей
        filterProject: [],//Фильр проектов
        //filterLabel: [],//Фильтр меток      
    },
    reducers: {
        //id_tab: 0-Исполнитель; 1-Наблюдатель; 2-Все задачи; 3-Выполненные;

        loadList(state, action) {
            const id_tab = action.payload.id_tab;
            const list = action.payload.list;

            state.list = [...state.list.filter(a => a.id_tab !== id_tab), ...list.map((item) => { return { ...item, filter_project: 0, filter_label: 0, filter_user: 0, id_tab: id_tab } })].sort((a, b) => a.ID - b.ID);
            state.listLoaded = [...state.listLoaded.filter(a => a.id_tab !== id_tab), { id_tab: id_tab }];
            state.filterProject = [...state.filterProject.filter(a => a.id_tab !== id_tab), ...filterProjectGenerate(list, id_tab)];
        },
        loadCheckList(state, action) {
            const id_tab = action.payload.id_tab;

            const list = action.payload.list.map(item => {
                return { ...item, id_tab: id_tab }
            })

            state.listCheckList = [...state.listCheckList.filter(a => a.id_tab !== id_tab), ...list];
        },
        loadUserList(state, action) {
            const id_tab = action.payload.id_tab;

            const list = action.payload.list.map(item => {
                return { ...item, id_tab: id_tab }
            })

            state.listUser = [...state.listUser.filter(a => a.id_tab !== id_tab), ...list];
        },
        /*loadLabelList(state, action) {
            const id_tab = action.payload.id_tab;

            const list = action.payload.list.map(item => {
                return { ...item, id_tab: id_tab }
            })

            state.listLabel = [...state.listLabel.filter(a => a.id_tab !== id_tab), ...list];
        },*/

        //Догружаются только метки, которых нет
        loadLabelList(state, action) {

            var list = [];

            //Убираем повторы меток. Иначе дублируются метки в случае когд аодна задача есть 2 раза в списке
            action.payload.list.map(item => {
                if (state.listLabel.filter(a => a.ID_Label === item.ID_Label & a.ID_Item === item.ID_Item).length === 0) {
                    list.push(item);
                }
            })

            state.listLabel = [...state.listLabel, ...list];
        },

        filterLabel(state, action) {
            const id_tab = action.payload.id_tab;
            const id_label = action.payload.id_label;

            if (id_label === -1) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab) {
                        return { ...item, filter_label: 0 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            else {
                state.list = state.list.map((task) => {
                    if (task.id_tab === id_tab) {
                        return { ...task, filter_label: state.listLabel.filter(a => /*a.id_tab === id_tab &*/ a.ID_Label === id_label & a.ID_Item === task.ID_TaskR).length == 0 ? 1 : 0 }
                    }
                    else {
                        return { ...task }
                    }
                })
            }
        },
        filterUser(state, action) {
            const id_tab = action.payload.id_tab;
            const id_user = action.payload.id_user;

            //Очишаем предыдущие значения
            state.list = state.list.map((item) => {
                if (item.id_tab === id_tab) {
                    return { ...item, filter_user: 0 }
                }
                else {
                    return { ...item }
                }
            })

            //Устанавливаем/снимаем фильтр
            if (id_user === -1) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.ID_User !== id_user) {
                        return { ...item, filter_user: 0 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            else {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.ID_User !== id_user) {
                        return { ...item, filter_user: 1 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },
        filterProject(state, action) {
            const id_tab = action.payload.id_tab;
            const id_project = action.payload.id_project;

            //Очишаем предыдущие значения
            state.list = state.list.map((item) => {
                if (item.id_tab === id_tab) {
                    return { ...item, filter_project: 0 }
                }
                else {
                    return { ...item }
                }
            })

            //Устанавливаем/снимаем фильтр
            if (id_project === -1) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.ID_Project !== id_project) {
                        return { ...item, filter_project: 0 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            else {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.ID_Project !== id_project) {
                        return { ...item, filter_project: 1 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },

        update(state, action) {
            const model = action.payload.model;
            const calendar = action.payload.calendar;


            console.log('task', model)

            const id_tab = calendar === true ? -1 : taskTabGet(model);

            //Обновляем задачи
            state.list = [...state.list.filter(a => a.ID !== model.ID), { ...model, filter_project: 0, filter_label: 0, filter_user: 0, id_tab: id_tab }].sort((a, b) => a.ID - b.ID);

            //Обновляем фильтр проектов
            if (model.ID_Project != null) {
                state.filterProject = [...state.filterProject.filter(a => a.id_tab !== id_tab), ...filterProjectGenerate(state.list.filter(a => a.id_tab === id_tab), id_tab)];
            }
        },
        //Действия при завершении одной задачи
        complete(state, action) {
            const ID = parseInt(action.payload.id);
            state.list = state.list.filter(a => a.ID !== ID);
        },
        //Действия при завершении всех задач
        completeMass(state, action) {
            const ids = action.payload.ids;//Список ИД завершенных задач

            const list_new = current(state.list).map((item) => {
                if (ids.filter(a => a == item.ID).length === 0) {
                    return item;
                }
            }).filter(a => a !== undefined)

            state.list = list_new;
        },
        //Обновление меток из настроек
        updateLabelSetting(state, action) {
            const data = action.payload.data;
            const id_task_r = action.payload.id_task_r;
            const id_tab = current(state.list).filter(a => a.ID_TaskR === id_task_r)[0].id_tab;
            state.listLabel = [...state.listLabel.filter(a => a.ID_Item !== id_task_r), ...data.map((item) => { return { ...item, id_tab: id_tab } })]
        },
        updateCheckList(state, action) {
            const data = action.payload.data;
            const id_task_r_tracker = action.payload.id_task;
            const id_tab = current(state.list).filter(a => a.ID === id_task_r_tracker)[0].id_tab;

            state.listCheckList = [...state.listCheckList.filter(a => a.ID_TaskR_Tracker !== id_task_r_tracker), ...data.map((item) => { return { ...item, id_tab: id_tab } })];
        },
        updateUser(state, action) {
            const data = action.payload.data;
            const id_task_r_tracker = action.payload.id_task;
            const id_tab = current(state.list).filter(a => a.ID === id_task_r_tracker)[0].id_tab;

            state.listUser = [...state.listUser.filter(a => a.ID_TaskR_Tracker !== id_task_r_tracker), ...data.map((item) => { return { ...item, id_tab: id_tab } })];
        },
        remove(state, action) {
            const id = action.payload.id;
            const id_tab = state.list.filter(a => a.ID === id)[0].id_tab;

            state.list = [...state.list.filter(a => a.ID !== id)];
            state.filterProject = [...state.filterProject.filter(a => a.id_tab !== id_tab), ...filterProjectGenerate(state.list.filter(a => a.id_tab === id_tab), id_tab)];
        },
        cleanFilter(state, action) {
            const id_tab = action.payload.id_tab;
            state.filterProject = [...state.filterProject.filter(a => a.id_tab !== id_tab)];
        },
        userView(state, action) {
            const id_task = action.payload.id_task;
            const id_user = action.payload.id_user;

            console.log('reducer')

            state.list = state.list.map(item => {
                if (item.ID === id_task) {
                    return { ...item, Viewed: true }
                }
                else {
                    return { ...item }
                }
            })

            state.listUser = state.listUser.map(item => {
                if (item.ID_TaskR_Tracker === id_task & item.ID_User === id_user) {
                    return { ...item, Viewed: true }
                }
                else {
                    return { ...item }
                }
            })
        },
    }
})
export const { loadList, loadLabelList, loadUserList, loadCheckList, update, updateUser, complete, completeMass, updateCheckList, updateLabelSetting, remove, filterLabel, filterProject, filterUser, cleanFilter, userView } = taskRTrackerList.actions
export default taskRTrackerList.reducer